






import { Component, Prop, Vue } from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import { PublishedApp } from '../../shared/models';
import { googleBmApi } from '../services/googlebmApi';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import Toast from '@/shared/services/toast';
import { GoogleBmInstalledApp } from '../models';
import { AgentConfigRequest } from '@/features/apps/googlebm/models/agentConfigRequest';
import GoogleBmAgentConfig from './googleBmAgentConfig.vue';
import {botsApi} from '@/features/bots/services/bots';
import {HANDLE_SERIOUS_ERROR} from '@/store/app/actionTypes';
import {BusinessHoursViewModel} from '@/features/bots/models';

@Component({
	components: { GoogleBmAgentConfig }
})
export default class GoogleBmAddAgent extends Vue {
	@Getter public currentApp!: PublishedApp;
	@Getter public currentWorkspace!: WorkspaceViewModel;

	@Prop() public app: GoogleBmInstalledApp | null;

	@Action(HANDLE_SERIOUS_ERROR) public handleSeriousError: any;

	public humanAvailability: BusinessHoursViewModel[] = [];
	public actionInProgress: boolean = true;

	public async mounted() {
		try {
			this.humanAvailability = await this.loadBusinessHours();
		} catch (error) {
			if (error.status !== 404) {
				this.handleSeriousError(error.message);
			}
		} finally {
			this.actionInProgress = false;
		}
	}

	public async onSave(request: AgentConfigRequest) {
		if (this.actionInProgress) {
			return;
		}
		this.actionInProgress = true;

		try {
			if (!this.app) {
				await this.installApp();
				this.app = {
					workspaceId: this.currentWorkspace.id,
					installId: this.currentApp.installedAppId,
					agents: []
				};
			}

			await googleBmApi.createAgent(this.currentWorkspace.id, request);

			this.$emit('configSaved');
		} catch (err) {
			Toast.showError(`Failed to save app : ${err.message}`);
		}
		this.actionInProgress = false;
	}

	public onCancel() {
		this.$router.push({ name: 'apps' });
	}

	public loadBusinessHours() {
		return botsApi.getBusinessHours(this.currentWorkspace.id);
	}

	private async installApp() {
		return googleBmApi.install({ workspaceId: this.currentWorkspace.id, installId: this.currentApp.installedAppId });
	}
}
